import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "count"];
  static values = { max: Number };

  connect() {
    this.update();
  }

  update() {
    const length = this.inputTarget.value.length;
    this.countTarget.textContent = `${length} / ${this.maxValue} characters`;
  }
}
